import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, LockIcon, FileTextIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 md:py-32 bg-slate-900 relative overflow-hidden" data-id="element-69">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-blue-600/10 blur-[100px] rounded-full pointer-events-none" data-id="element-70" />

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-71">
        <div className="bg-slate-800 rounded-3xl p-8 md:p-16 border-2 border-blue-500/30 shadow-[0_0_50px_rgba(37,99,235,0.15)] text-center" data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-73">
            Recupera tus noches y tu energía
          </h2>

          <p className="text-xl text-slate-300 mb-10" data-id="element-74">
            Por menos de lo que cuesta un café y un postre. Obtén el Protocolo
            Adiós Insomnio 3AM hoy mismo.
          </p>

          <div className="mb-10" data-id="element-75">
            <p className="text-blue-400 font-semibold uppercase tracking-wider text-sm mb-2" data-id="element-76">
              Precio Especial de Lanzamiento
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-77">
              <span className="text-6xl md:text-7xl font-extrabold text-white" data-id="element-78">
                $24.900
              </span>
              <span className="text-2xl text-slate-400 font-medium mt-4" data-id="element-79">
                COP
              </span>
            </div>
          </div>

          <div className="max-w-md mx-auto mb-8" data-id="element-80">
            <CTAButton className="w-full" onClick={() => window.location.href = 'https://solucionactiva.com/cart/51222339584304:1'} data-id="element-81" />
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-slate-400 text-sm" data-id="element-82">
            <div className="flex items-center gap-2" data-id="element-83">
              <LockIcon className="w-4 h-4 text-green-400" data-id="element-84" />
              <span data-id="element-85">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-86">
              <FileTextIcon className="w-4 h-4 text-blue-400" data-id="element-87" />
              <span data-id="element-88">Acceso instantáneo en PDF</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-89">
              <ShieldCheckIcon className="w-4 h-4 text-purple-400" data-id="element-90" />
              <span data-id="element-91">Garantía de satisfacción</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}